if (!customElements.get('load-more-toggle')) {
  customElements.define(
    'load-more-toggle',
    class LoadMoreToggle extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('button');
        if (!this.button) return;
        this.batchSize = parseInt(this.dataset.batchSize, 10) || 1;
        this.button.addEventListener('click', this.showMore.bind(this));
      }

      showMore() {
        const slider = document.getElementById(this.dataset.sliderId);
        if (!slider) return;

        const hiddenItems = Array.from(slider.querySelectorAll('[data-load-more-item][hidden]'));
        hiddenItems.slice(0, this.batchSize).forEach((item) => item.removeAttribute('hidden'));

        const remaining = slider.querySelectorAll('[data-load-more-item][hidden]').length;
        if (remaining === 0) {
          this.setAttribute('hidden', 'hidden');
        }

        const sliderComponent = slider.closest('slider-component');
        if (sliderComponent && typeof sliderComponent.resetPages === 'function') {
          requestAnimationFrame(() => sliderComponent.resetPages());
        }
      }
    }
  );
}
